import React from 'react';
import { ContentSection } from '../ui/ContentSection';
import { PieChart, Users, Zap } from 'lucide-react';
import { motion } from 'framer-motion';
export function Mechanism() {
  return <ContentSection background="gray" data-id="element-66">
      <div className="grid md:grid-cols-2 gap-12 items-center mb-16" data-id="element-67">
        <div data-id="element-68">
          <span className="text-amber-600 font-bold tracking-wider text-sm uppercase mb-4 block" data-id="element-69">
            MECANISMO / CONTENIDO CLAVE
          </span>
          <h2 className="text-3xl md:text-5xl font-bold text-[#1A1A1A]" data-id="element-70">
            Los 3 pilares del sistema
          </h2>
        </div>
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8,
        ease: 'easeOut'
      }} data-id="element-71">
          <img src="https://res.cloudinary.com/dyxo8wdrc/image/upload/f_auto,q_auto/v1766234477/Gemini_Generated_Image_bqfcaqbqfcaqbqfc_baaokv.png" alt="Los 3 pilares del sistema" className="w-full h-auto rounded-2xl shadow-xl" data-id="element-72" />
          <p className="mt-6 text-center text-gray-600 leading-relaxed text-sm md:text-base" data-id="element-73">
            Este no es contenido suelto. Es un sistema que ya ha sido aplicado
            por mujeres que lideran, venden y sostienen resultados reales.
          </p>
        </motion.div>
      </div>

      <div className="space-y-16" data-id="element-74">
        {/* Pillar 1 */}
        <div className="flex flex-col md:flex-row gap-8 items-start" data-id="element-75">
          <div className="w-full md:w-1/3 flex flex-col items-center md:items-start" data-id="element-76">
            <div className="w-16 h-16 bg-amber-100 rounded-2xl flex items-center justify-center text-amber-600 mb-6" data-id="element-77">
              <PieChart className="w-8 h-8" data-id="element-78" />
            </div>
            <h3 className="text-2xl font-bold text-gray-900 mb-2 text-center md:text-left" data-id="element-79">
              El 80/20 sin romanticismo
            </h3>
          </div>
          <div className="w-full md:w-2/3 prose prose-lg text-gray-600" data-id="element-80">
            <p data-id="element-81">
              Todo el mundo habla del 80/20. Pocos lo aplican de verdad. Cuando
              lo haces, descubres algo incómodo: solo un 20% de lo que haces
              genera avance real. El otro 80% solo te mantiene ocupada.
            </p>
            <p className="font-bold text-gray-900" data-id="element-82">
              Este libro te enseña a aplicar el 80/20 sin romanticismo. Tu 20%…
              o nada.
            </p>
          </div>
        </div>

        {/* Pillar 2 */}
        <div className="flex flex-col md:flex-row gap-8 items-start" data-id="element-83">
          <div className="w-full md:w-1/3 flex flex-col items-center md:items-start" data-id="element-84">
            <div className="w-16 h-16 bg-amber-100 rounded-2xl flex items-center justify-center text-amber-600 mb-6" data-id="element-85">
              <Users className="w-8 h-8" data-id="element-86" />
            </div>
            <h3 className="text-2xl font-bold text-gray-900 mb-2 text-center md:text-left" data-id="element-87">
              Delegar no es soltar tareas
            </h3>
          </div>
          <div className="w-full md:w-2/3 prose prose-lg text-gray-600" data-id="element-88">
            <p data-id="element-89">
              Si todo depende de ti, tu crecimiento tiene un límite. Delegar no
              es desaparecer. Es diseñar un sistema donde tú haces lo que solo
              tú puedes hacer y el resto se sostiene sin drenarte.
            </p>
            <p className="font-bold text-gray-900" data-id="element-90">Es recuperar poder.</p>
          </div>
        </div>

        {/* Pillar 3 */}
        <div className="flex flex-col md:flex-row gap-8 items-start" data-id="element-91">
          <div className="w-full md:w-1/3 flex flex-col items-center md:items-start" data-id="element-92">
            <div className="w-16 h-16 bg-amber-100 rounded-2xl flex items-center justify-center text-amber-600 mb-6" data-id="element-93">
              <Zap className="w-8 h-8" data-id="element-94" />
            </div>
            <h3 className="text-2xl font-bold text-gray-900 mb-2 text-center md:text-left" data-id="element-95">
              Decisiones pequeñas, impacto a 5 años
            </h3>
          </div>
          <div className="w-full md:w-2/3 prose prose-lg text-gray-600" data-id="element-96">
            <p data-id="element-97">
              La mayoría no arruina su vida con un gran error. La arruina con
              decisiones pequeñas repetidas: "yo me encargo", "después veo eso",
              "una más".
            </p>
            <p className="font-bold text-gray-900" data-id="element-98">
              Este libro te entrena para decidir desde energía, claridad y
              libertad.
            </p>
          </div>
        </div>
      </div>
    </ContentSection>;
}